import Layout from '@/layout/index.vue';

export default [
  {
    path: '/facilityManage',
    redirect: '/facilityManage/home/index',
  },

  {
    path: '/facilityManage/home',
    component: Layout,
    name: 'facilityManageHome',
    meta: {
      title: '首页',
      icon: 'el-icon-s-home',
    },
    children: [
      {
        path: 'index',
        name: 'facilityManageIndex',
        component: () => import('@/views/facilityHome/index.vue'),
        meta: { title: '首页概览' },
      },
    ],
  },

  {
    path: '/facilityManage/formal',
    component: Layout,
    name: 'facilityManage',
    meta: {
      title: '工程服务',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'otherService',
        name: 'otherService',
        component: () => import('@/views/facilityManage/otherService'),
        meta: { title: '其他服务', icon: 'el-icon-s-management' },
      },
      {
        path: 'technicalReform',
        name: 'technicalReform',
        component: () => import('@/views/facilityManage/technicalReform'),
        meta: { title: '技术改造', icon: 'el-icon-s-management' },
      },
      {
        path: 'technicalReformDetail',
        name: 'technicalReformDetail',
        component: () => import('@/views/facilityManage/technicalReformDetail'),
        meta: { title: '项目详情' },
        hidden: true,
      },
    ],
  },

  {
    path: '/operationManage/formal',
    component: Layout,
    name: 'operationManage',
    meta: {
      title: '运维服务',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'manpowerService',
        name: 'manpowerService',
        component: () => import('@/views/operationManage/manpowerService/index.vue'),
        meta: { title: '人力服务', icon: 'el-icon-s-management' },
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: () => import('@/views/operationManage/maintenance/index.vue'),
        meta: { title: '综合维保', icon: 'el-icon-s-management' },
      },
      {
        path: 'drillService',
        name: 'drillService',
        component: () => import('@/views/operationManage/drill/index.vue'),
        meta: { title: '演练工单', icon: 'el-icon-s-management' },
      },
      {
        path: 'qualityDashboard',
        name: 'qualityDashboard',
        component: () => import('@/views/operationManage/qualityDashboard/index.vue'),
        meta: { title: '质量看板', icon: 'el-icon-data-analysis' },
      },
    ],
  },

  // {
  //   path: '/massManage/formal',
  //   component: Layout,
  //   name: 'massManage',
  //   meta: {
  //     title: '质量管理',
  //     icon: 'el-icon-s-finance',
  //     alwaysShow: true, // 即使只有一个子路由也显示父级菜单
  //   },
  //   children: [
  //     {
  //       path: 'massManage',
  //       name: 'massManage',
  //       component: () => import('@/views/operationManage/manpowerService/index.vue'),
  //       meta: { title: '异常工单', icon: 'el-icon-s-management' },
  //     },
  //   ],
  // },
];
